import { envSchema } from '@qapline/env';

export const env = envSchema.parse(import.meta.env);
